import React from 'react';
import PropTypes from 'prop-types';
import Typist from 'react-typist';
import Switch from 'react-switch';

import CircularAudioWave from './graph/circular-audio-wave';

import '../styles/Home.scss';

/* global CustomEvent */

export default class AudioWaves extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      callAnswered: !this.props.data.ringer,
      showCaptions: true,
      showOptions: false,
      step: this.props.data.intro,
    };

    const ua = window.navigator.userAgent;
    this.isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Windows ') > -1 || (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1);
    this.wave = {};
  }

  componentDidMount() {
    if (!this.isIE && !!this.props.data.ringer) {
      this.wave = new CircularAudioWave(document.getElementById('ringer-waves'), this.onAudioEnd, {
        loop: true,
      });
      this.wave.loadAudio(this.props.data.ringer.audio);
    } else {
      this.onAudioEnd();
    }
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.log(info);
  }

  clearAudio = () => {
    if (!this.isIE) {
      this.wave.stop && this.wave.stop();
      delete this.wave;
      this.wave = {};
    }
  };

  renderCall = () => {
    this.clearAudio();

    setTimeout(() => {
      this.setState({ callAnswered: true }, () => {
        if (!this.isIE && this.state.step.audio !== 'NONE') {
          this.wave = new CircularAudioWave(document.getElementById('audio-waves'), this.onAudioEnd);
          this.wave.loadAudio(this.state.step.audio);
        }
      });
    }, 500);
  };

  onAudioEnd = () => {
    if (this.state.callAnswered) {
      this.setState({ showOptions: true });
    }
  };

  setActiveStep = (step = {}) => {
    if (step.audio && step.audio !== 'NONE') {
      this.clearAudio();
      
      setTimeout(() => {
        this.setState({ showOptions: false, showCaptions: false, step }, () => {
          if (!this.isIE) {
            this.wave = new CircularAudioWave(document.getElementById('audio-waves'), this.onAudioEnd);
            this.wave.loadAudio(this.state.step.audio);
          }

          this.setState({ showCaptions: true });
        });
      }, 500);
    } else if (step.audio === 'NONE') {
      this.setState({ showOptions: false, showCaptions: false, step }, () => {
        this.setState({ showCaptions: true });
      });
    } else {
      const event = new CustomEvent('modal', {
        detail: step,
      });
      window.dispatchEvent(event);
    }
  };

  renderCaptions = () => {
    const { step, callAnswered } = this.state;
    const { data } = this.props;
    const caption = step.caption;

    if (callAnswered && caption && caption.length) {
      return (
        <div id='audio-captions'>
          <Typist
            className='typing-animation'
            startDelay={this.isIE ? 0 : data.delay}
            cursor={{ show: false }}
            avgTypingDelay={data.typeSpeed}
            onTypingDone={this.onAudioEnd}
          >
            {caption}
          </Typist>
        </div>
      );
    }
  };

  renderOptions = () => {
    const options = this.state.step.options;
    const buttons = [];

    if (this.state.callAnswered && options) {
      Object.keys(options).forEach(key => {
        const option = options[key];
        buttons.push(
          <button key={key} onClick={this.setActiveStep.bind(this, option.step)}>
            {option.text}
          </button>,
        );
      });
    }

    return buttons;
  };

  renderRinger = () => {
    return (
      <div id='ringer-container'>
        <div id='caller-name'>{this.props.data.call.name}</div>
        <div id='phone-number'>{this.props.data.call.number}</div>
        <div id='ringer-waves' />
        {!this.state.callAnswered && (
          <>
            <Switch
              className='slider'
              width={200}
              height={40}
              onChange={this.renderCall}
              checked={false}
              checkedIcon={false}
              uncheckedIcon={false}
            />
            <div className='slide-to-open'>Slide</div>
          </>
        )}
      </div>
    );
  };

  render() {
    const { callAnswered, showOptions, showCaptions } = this.state;

    return (
      <div className={`phone-container ${!callAnswered && !this.isIE ? 'ringing' : ''}`}>
        {!callAnswered ? (
          this.renderRinger()
        ) : (
          <div id='call-container'>
            <div id='audio-waves' />
            <div id='caller-name'>{this.props.data.call.name}</div>
            <div id='phone-number'>{this.props.data.call.number}</div>
            <div id='caller-avatar'>
              <img src={this.props.data.call.avatar} alt='Caller avatar' />
            </div>
            {showCaptions && this.renderCaptions()}
            <div id='option-buttons'>{showOptions && this.renderOptions()}</div>
          </div>
        )}
      </div>
    );
  }
}

AudioWaves.propTypes = {
  data: PropTypes.object.isRequired,
};
